<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Login" });
import ForgotPassword from "../forgot-password/ForgotPassword.svelte";
import { Form, Modal } from "../../../../components/index.js";
import { Link, Paragraph } from "../../../../typography/index.js";
import { InputEmail, InputPassword } from "../../../user/index.js";
import Button from "../../../../elements/button/Button.svelte";
import { t } from "svelte-i18n";
import { createEventDispatcher } from "svelte";
import { AUTHENTICATION } from "../../services/store.js";
import * as API from "../../services/api.js";
export let registrationUrl = void 0;
const FORGOT_PASSWORD_HASH = "#forgot-password";
let error = "";
const dispatch = createEventDispatcher();
const clearEmail = () => {
    $AUTHENTICATION.email = void 0;
};
const onSubmit = async () => {
    const RESPONSE = await API.login($AUTHENTICATION);
    if ("error" in RESPONSE) {
        ({ error } = RESPONSE);
        return;
    }
    dispatch("success");
    $AUTHENTICATION.password = void 0;
};
</script>

<Form { onSubmit } { error } id = 'login' css = 'max-w-[400px]'>

    {#if Boolean(error)}
        <Paragraph label = { error } css = 'mt-4' color = 'error' />
    {/if}

    <InputEmail bind:value = { $AUTHENTICATION.email } />

    <InputPassword bind:value = { $AUTHENTICATION.password } autocomplete = 'current-password'/>

    <div class = 'text-right text-xs -mt-2 relative z-10'>
        <Link url = { FORGOT_PASSWORD_HASH } label = 'component.session.login.forgot_password_link' />
    </div>

    <svelte:fragment slot = 'footer'>

        <Button
            type = 'submit'
            icon = 'arrowRight'
            label = 'component.session.login.submit_button'
            css = 'w-full'
        />

        {#if registrationUrl !== undefined}

            <Paragraph css = 'mt-6' align = 'center'>

                { $t('component.session.login.registration_text') }

                <Link
                    url = { registrationUrl }
                    label = 'component.session.login.registration_link'
                    css = 'underline'
                    on:click = { clearEmail }
                />

            </Paragraph>

        {/if}

    </svelte:fragment>

</Form>

<Modal hash = { FORGOT_PASSWORD_HASH }>
    <ForgotPassword />
</Modal>